import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getEntityTypes} from 'src/openapi/admin/apis/GetEntityTypesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectAccountEntityTypes} from './services/dictionary-slice';

export const useAccountEntityTypes = () => {
    const apiDispatch = useAppDispatch();
    const accountEntityTypes = useSelector(selectAccountEntityTypes);

    const loadAccountEntityTypes = useCallback(() => {
        if (!accountEntityTypes.length) {
            apiDispatch(getEntityTypes());
        }
    }, [accountEntityTypes.length, apiDispatch]);

    const getAccountEntityTypeByCode = useCallback((code: string) => {
        return accountEntityTypes.find(e => e.code === code);
    }, [accountEntityTypes]);

    return {accountEntityTypes, loadAccountEntityTypes, getAccountEntityTypeByCode};
};
